import { ENUM_AdvisorUserPermissionLevel } from '@api-new/common';
import { CompanyTableFilterModel } from '@platform/company/models/company-table-filter.model';
import { CompanyTableRowModel } from '@platform/company/models/company-table.model';
import { RowDefinitionTypeEnum } from '@shared/components/table/enums/row-definition-type.enum';
import { TableRowDefinitionModel } from '@shared/components/table/models/table-row-definition.model';
import { PermissionEnum } from '@shared/enums/permission.enum';
import { HasCurrentUserRequiredPermissionsFunctionModel } from '@shared/services/permission.service';

export const companyTableFilterDefaults: CompanyTableFilterModel = {
  tradingNameContains: '',
  networkIds: [],
  betterDealAlertNotificationsEnabled: null,
  homeReportNotificationsEnabled: null,
};

export const companyTableRowDefinition = (
  hasCurrentUserRequiredPermissions: HasCurrentUserRequiredPermissionsFunctionModel,
): TableRowDefinitionModel<CompanyTableRowModel>[] => [
  {
    columnLabel: 'Trading name',
    columnKey: 'tradingName',
    sortKey: 'byTradingName',
    type: RowDefinitionTypeEnum.Text,
    isFrozen: true,
    width: {
      min: '240px',
      max: '240px',
    },
  },
  {
    columnLabel: 'logo',
    columnKey: 'logo',
    type: RowDefinitionTypeEnum.Image,
    width: {
      min: '150px',
      max: '150px',
    },
  },
  {
    columnLabel: 'id',
    columnKey: 'id',
    type: RowDefinitionTypeEnum.Text,
    sortKey: 'byCompanyId',
    width: {
      min: '48px',
      max: '48px',
    },
  },
  {
    columnLabel: 'advisers',
    columnKey: 'advisorUserCount',
    type: RowDefinitionTypeEnum.Number,
    sortKey: 'byAdvisorUserCount',
    width: {
      min: '100px',
      max: '100px',
    },
  },
  {
    columnLabel: 'clients',
    columnKey: 'clientUserCount',
    type: RowDefinitionTypeEnum.Number,
    sortKey: 'byClientUserCount',
    width: {
      min: '100px',
      max: '100px',
    },
  },
  {
    columnLabel: 'mortgages',
    columnKey: 'mortgageCount',
    type: RowDefinitionTypeEnum.Number,
    sortKey: 'byMortgageCount',
    width: {
      min: '100px',
      max: '130px',
    },
  },
  {
    columnLabel: 'Active ref. codes',
    columnKey: 'activeReferralCount',
    type: RowDefinitionTypeEnum.Number,
    sortKey: 'byActiveReferralCount',
    width: {
      min: '120px',
      max: '120px',
    },
    isHidden: !hasCurrentUserRequiredPermissions([
      {
        permission: PermissionEnum.ReferralRead,
      },
    ]),
  },
  {
    columnLabel: 'Network',
    columnKey: 'networkTradingName',
    type: RowDefinitionTypeEnum.Text,
    sortKey: 'byNetworkTradingName',
    width: {
      min: '100px',
      max: '100px',
    },
    isHidden: !hasCurrentUserRequiredPermissions([
      {
        permission: PermissionEnum.CompanyRead,
        permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_FULL,
      },
    ]),
  },
  {
    columnLabel: 'Client notifications',
    columnKey: 'notificationSettings',
    type: RowDefinitionTypeEnum.NotificationSettings,
    width: {
      min: '125px',
      max: '135px',
    },
  },
];
